export default __webpack_public_path__ + "static/media/icon-visibility-hidden.e19e709e.svg";